import { Injectable } from '@angular/core';
import Swal from 'sweetalert2'
/***** Rxjs *****/
import { take } from 'rxjs/operators';
/***** Services *****/
import { LanguageService } from './language.service';
import { TransfromsService } from './transfroms.service';

export interface AlertOptions {
  icon?: 'success' | 'error' | 'warning' | 'info' | 'question';
  title?: string;
  text?: string;
  html?: string;
  timer?: number;
  timerProgressBar?: boolean;
  allowOutsideClick?: boolean;
  showConfirmButton?: boolean;
  confirmButtonText?: string;
  showDenyButton?: boolean;
  denyButtonText?: string;
  showCancelButton?: boolean,
  cancelButtonText?: string,
  reverseButtons?: boolean,
  input?: 'radio' | 'checkbox' | 'text';
  inputOptions?: Object;
  inputValue?: string;
  preConfirm?: any; // 按下確定按鈕前觸發
  onOpen?: any; //
  onClose?: any;
  focusConfirm?: boolean;
  focusDeny?: boolean;
  focusCancel?: boolean;
  didClose?: any;
};

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(
    private languageService: LanguageService,
    private transformService: TransfromsService,
  ) { }

  /***** Api Error Message *****/
  async apiError(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.languageService.translate
      .get(['翻譯key'])
      .pipe(take(1))
      .subscribe(i18n => {

          Swal.fire({
            icon: 'error',
            title: 'API請求錯誤',
            text: '請稍後再試',
            confirmButtonText: '確定',
          }).then(() => {
            resolve();
          });

        })
    });
  }
  async timeoutError(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.languageService.translate
      .get(['翻譯key'])
      .pipe(take(1))
      .subscribe(i18n => {

          Swal.fire({
            icon: 'error',
            title: 'API請求逾時',
            text: '請稍後再試',
            confirmButtonText: '確定',
          }).then(() => {
            resolve();
          });

        })
    });
  }  
  async unknownError(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.languageService.translate
      .get(['翻譯key'])
      .pipe(take(1))
      .subscribe(i18n => {

          Swal.fire({
            icon: 'error',
            title: '發生未知的錯誤',
            text: '請稍後再試',
            confirmButtonText: '確定',
          }).then(() => {
            resolve();
          });

        })
    });
  }

  updateSite(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: '網頁更新',
        text: '網頁有新的版本，是否進行更新?',
        icon: 'warning',
        confirmButtonText: '是',
        showDenyButton: true,
        denyButtonText: `否`
      }).then((result) => {
        if (result.isConfirmed) {
          resolve(true);
        } else if (result.isDenied) {
          Swal.fire('新版本將會在刷新網頁或下一次啟動時自動更新', '', 'info')
          resolve(false);
        }
      })
    });
  }
  installToHomeScreen(promptEvent): Promise<boolean> {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: '安裝到桌面',
        text: '請點選繼續，將此應用程式安裝到此裝置的桌面。',
        icon: 'warning',
        confirmButtonText: '繼續',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          if (promptEvent) {
            console.log('install');
            promptEvent.prompt();
            promptEvent.userChoice
            .then((choiceResult) => {
              if (choiceResult.outcome === 'accepted') {
                console.log('User accepted the A2HS prompt');
                resolve(true);
              } else {
                console.log('User dismissed the A2HS prompt');
                resolve(false);
              }
            });
          }
        }
      })
    });
  }

  // code: 999 自定義
  alert(code: number, myAlertOptions?: AlertOptions) {
    return new Promise<any>((resolve, reject) => {
      let alertOptions: AlertOptions = {
        title: '',
        text: '',
        html: '',
        confirmButtonText: '',
        allowOutsideClick: false,
        showDenyButton: false,
        denyButtonText: '',
      };

      switch (code) {
        case 999:
          alertOptions = Object.assign(alertOptions, myAlertOptions);
          break;
      }

      Swal.fire(alertOptions).then((result) => {
        if (result.isConfirmed) {
          resolve(true);
        } else if (result.isDenied) {
          resolve(false);
        }
      })

    });
  }

  test() {
    Swal.mixin({
      toast: true,
      position: 'top',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    }).fire({
      icon: 'error',
      title: 'Signed in successfully'
    })
  }

  deleteTableRow(myAlertOptions?: AlertOptions): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let alertOptions: AlertOptions = {
        icon: 'question',
        title: '確定要刪除資料嗎?',
        text: '資料刪除後將無法復原',
        showConfirmButton: true,
        confirmButtonText: '是',
        showDenyButton: true,
        denyButtonText: '否',
        focusConfirm: false,
        focusDeny: true,
        reverseButtons: true,
        allowOutsideClick: true,
      };
      alertOptions = Object.assign(alertOptions, myAlertOptions);

      Swal.fire(alertOptions).then((result) => {
        if (result.isConfirmed) {
          resolve(true);
        } else {
          resolve(false);
        }
      })

    });
  }
  formDataUnsaved(myAlertOptions?: AlertOptions): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let alertOptions: AlertOptions = {
        title: '確定要取消操作嗎?',
        text: '資料尚未儲存，取消後將無法恢復未儲存的資料',
        showConfirmButton: true,
        confirmButtonText: '是',
        showDenyButton: true,
        denyButtonText: '否',
        focusConfirm: false,
        focusDeny: true,
        reverseButtons: true,
        allowOutsideClick: true,
      };
      alertOptions = Object.assign(alertOptions, myAlertOptions);

      Swal.fire(alertOptions).then((result) => {
        if (result.isConfirmed) {
          resolve(true);
        } else {
          resolve(false);
        }
      })

    });
  }
  formTabToSave(myAlertOptions?: AlertOptions): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let alertOptions: AlertOptions = {
        title: '是否儲存資料?',
        showConfirmButton: true,
        confirmButtonText: '是',
        showDenyButton: true,
        denyButtonText: '否',
        focusConfirm: false,
        focusDeny: true,
        reverseButtons: true,
        allowOutsideClick: true,
      };
      alertOptions = Object.assign(alertOptions, myAlertOptions);

      Swal.fire(alertOptions).then((result) => {
        if (result.isConfirmed) {
          resolve(true);
        } else {
          resolve(false);
        }
      })

    });
  }
  formContinueToAdd(myAlertOptions?: AlertOptions): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let alertOptions: AlertOptions = {
        title: '是否繼續新增資料?',
        showConfirmButton: true,
        confirmButtonText: '是',
        showDenyButton: true,
        denyButtonText: '否',
        focusConfirm: false,
        focusDeny: true,
        reverseButtons: true,
        allowOutsideClick: true,
      };
      alertOptions = Object.assign(alertOptions, myAlertOptions);

      Swal.fire(alertOptions).then((result) => {
        if (result.isConfirmed) {
          resolve(true);
        } else {
          resolve(false);
        }
      })

    });
  }
  formContinueToAdd_AfterTabToSave(myAlertOptions?: AlertOptions): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let alertOptions: AlertOptions = {
        title: '是否繼續新增資料?',
        text: '資料尚未儲存，取消後將無法恢復未儲存的資料',
        showConfirmButton: true,
        confirmButtonText: '是',
        showDenyButton: true,
        denyButtonText: '否',
        focusConfirm: false,
        focusDeny: true,
        reverseButtons: true,
        allowOutsideClick: true,
      };
      alertOptions = Object.assign(alertOptions, myAlertOptions);

      Swal.fire(alertOptions).then((result) => {
        if (result.isConfirmed) {
          resolve(true);
        } else {
          resolve(false);
        }
      })

    });
  }

  buttonModeAlert(btnType: string, btnMode: number, myAlertOptions?: AlertOptions): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let title = '';
      let html = '';

      switch(btnType) {
        case 'add':
          title = '新增動作無效';
          html = '<p style="text-align: left;">編輯模式下，無法執行新增動作，請先點選[取消]或[儲存]按鈕以完成當前操作。</p>';
          break;
        case 'revise':
          if (btnMode === 0) {
            title = '更新動作無效';
            html = '<p style="text-align: left;">請先鎖定一筆資料列，再執行更新動作。</p>';
          } else {
            title = '更新動作無效';
            html = '<p style="text-align: left;">編輯模式下，無法執行更新動作，請先點選[取消]或[儲存]按鈕以完成當前操作。</p>';
          }
          break;
        case 'delete':
          if (btnMode === 0) {
            title = '刪除動作無效';
            html = '<p style="text-align: left;">請先鎖定一筆資料列，再執行刪除動作。</p>';
          } else {
            title = '刪除動作無效';
            html = '<p style="text-align: left;">編輯模式下，無法執行刪除動作，請先點選[取消]或[儲存]按鈕以完成當前操作。</p>';
          }
          break;
        case 'cancel':
          title = '取消動作無效';
          html = '<p style="text-align: left;">瀏覽模式下，無法執行取消動作，請先點選[新增]或[更新]按鈕，進入編輯模式。</p>';
          break;
        case 'save':
          title = '儲存動作無效';
          html = '<p style="text-align: left;">瀏覽模式下，無法執儲存動作，請先點選[新增]或[更新]按鈕，進入編輯模式。</p>';
          break;
      }

      let alertOptions: AlertOptions = {
        icon: 'error',
        title,
        html,
        showConfirmButton: true,
        confirmButtonText: '好',
        showDenyButton: false,
        focusConfirm: true,
        allowOutsideClick: true,
      };
      alertOptions = Object.assign(alertOptions, myAlertOptions);

      Swal.fire(alertOptions).then((result) => {
        if (result.isConfirmed) {
          resolve(true);
        } else {
          resolve(false);
        }
      })

    });
  }

  /***** CRUD *****/
  cancelBtnAlert(myAlertOptions?: AlertOptions): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let alertOptions: AlertOptions = {
        icon: 'warning',
        title: '確定要取消嗎?',
        text: '資料尚未儲存，取消後將無法恢復資料',
        showConfirmButton: true,
        confirmButtonText: '確定',
        showDenyButton: true,
        denyButtonText: '留下',
        focusConfirm: false,
        focusDeny: true,
        reverseButtons: true,
        allowOutsideClick: true,
      };
      alertOptions = Object.assign(alertOptions, myAlertOptions);

      Swal.fire(alertOptions).then((result) => {
        if (result.isConfirmed) {
          resolve(true);
        } else {
          resolve(false);
        }
      })

    });
  }
  deleteBtnAlert(myAlertOptions?: AlertOptions): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let alertOptions: AlertOptions = {
        icon: 'warning',
        title: '確定要刪除資料嗎?',
        text: '資料刪除後將無法復原',
        showConfirmButton: true,
        confirmButtonText: '是',
        showDenyButton: true,
        denyButtonText: '否',
        focusConfirm: false,
        focusDeny: true,
        reverseButtons: true,
        allowOutsideClick: true,
      };
      alertOptions = Object.assign(alertOptions, myAlertOptions);

      Swal.fire(alertOptions).then((result) => {
        if (result.isConfirmed) {
          resolve(true);
        } else {
          resolve(false);
        }
      })

    });
  }

  /***** Logout *****/
  logoutBtnAlert(myAlertOptions?: AlertOptions): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let alertOptions: AlertOptions = {
        icon: 'warning',
        title: '確定要登出嗎?',
        showConfirmButton: true,
        confirmButtonText: '確定',
        showDenyButton: true,
        denyButtonText: '留下',
        focusConfirm: false,
        focusDeny: true,
        reverseButtons: true,
        allowOutsideClick: true,
      };
      alertOptions = Object.assign(alertOptions, myAlertOptions);

      Swal.fire(alertOptions).then((result) => {
        if (result.isConfirmed) {
          resolve(true);
        } else {
          resolve(false);
        }
      })

    });
  }

  /***** Custom *****/
  bsstsccrBtnAlert_1(myAlertOptions?: AlertOptions): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let alertOptions: AlertOptions = {
        icon: 'error',
        title: '無法刪除',
        text: '此筆資料為必要的基本設定，只能被修改，無法被刪除。',
        showConfirmButton: true,
        confirmButtonText: '確定',
        showDenyButton: false,
        denyButtonText: '否',
        focusConfirm: false,
        focusDeny: true,
        reverseButtons: true,
        allowOutsideClick: true,
      };
      alertOptions = Object.assign(alertOptions, myAlertOptions);

      Swal.fire(alertOptions).then((result) => {
        resolve(true);
      })

    });
  }
  bsstsccrBtnAlert_2(myAlertOptions?: AlertOptions): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let alertOptions: AlertOptions = {
        icon: 'error',
        title: '無法刪除',
        text: '請先刪除目前加購張數最大的資料列。',
        showConfirmButton: true,
        confirmButtonText: '確定',
        showDenyButton: false,
        denyButtonText: '否',
        focusConfirm: false,
        focusDeny: true,
        reverseButtons: true,
        allowOutsideClick: true,
      };
      alertOptions = Object.assign(alertOptions, myAlertOptions);

      Swal.fire(alertOptions).then((result) => {
        resolve(true);
      })

    });
  }

  addDtHeader(): Promise<any> {
    return new Promise((resolve, reject) => {
      Swal.fire({
        icon: 'warning',
        title: '新增表頭',
        input: 'text',
        inputPlaceholder: '輸入表頭名稱',
        inputValue: '',
        inputAttributes: {
          maxlength: '10',
          autocapitalize: 'off',
          autocorrect: 'off',
        },
        showCancelButton: true,
        cancelButtonText: '取消',
        confirmButtonText: '新增下一個',
        showLoaderOnConfirm: true,
        reverseButtons: true,
        preConfirm: (value) => {
          if (!value) {
            Swal.showValidationMessage('輸入表頭名稱'); 
          } else {
            return value;
          }
        },
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          resolve(result.value);
        } else {
          resolve(false);
        }
      });
    });
  }
  addMediaLabel(): Promise<any> {
    return new Promise((resolve, reject) => {
      Swal.fire({
        icon: 'info',
        title: '新增標籤',
        text: '輸入標籤名稱',
        input: 'text',
        inputPlaceholder: '10個字元以內',
        inputValue: '',
        inputAttributes: {
          maxlength: '10',
          autocapitalize: 'off',
          autocorrect: 'off',
        },
        showCancelButton: true,
        cancelButtonText: '取消',
        confirmButtonText: '確定',
        showLoaderOnConfirm: true,
        reverseButtons: true,
        preConfirm: (value) => {
          if (!value) {
            Swal.showValidationMessage('請輸入標籤名稱'); 
          } else {
            return value;
          }
        },
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          resolve(result.value);
        } else {
          resolve(false);
        }
      });
    });
  }

  input_password(): Promise<any> {
    return new Promise((resolve, reject) => {
      Swal.fire({
        icon: 'warning',
        title: '歡迎使用養鴨協會後台系統',
        text: '第一次登入請先修改密碼',
        input: 'text',
        inputPlaceholder: '輸入密碼',
        inputValue: '',
        inputAttributes: {
          maxlength: '20',
          autocapitalize: 'off',
          autocorrect: 'off',
        },
        showCancelButton: false,
        confirmButtonText: '確定',
        showLoaderOnConfirm: true,
        reverseButtons: true,
        preConfirm: (password) => {
          if (!password) {
            Swal.showValidationMessage('請輸入密碼'); 
          } else {
            return password;
          }
        },
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          resolve(result.value);
        } else {
          resolve(false);
        }
      });
    });
  }
  input_photoName(): Promise<any> {
    return new Promise((resolve, reject) => {
      Swal.fire({
        icon: 'info',
        title: '輸入照片名稱',
        text: '20字以內',
        input: 'text',
        inputPlaceholder: '',
        inputValue: '',
        inputAttributes: {
          maxlength: '20',
          autocapitalize: 'off',
          autocorrect: 'off',
        },
        showCancelButton: true,
        cancelButtonText: '取消',
        showDenyButton: true,
        denyButtonText: '略過',
        confirmButtonText: '完成',
        showLoaderOnConfirm: true,
        reverseButtons: true,
        preConfirm: (name) => {
          if (!name) {
            Swal.showValidationMessage('請輸入照片名稱'); 
          } else {
            return name;
          }
        },
        allowOutsideClick: false,
      }).then((result) => {
        // console.log(result);
        if (result.isConfirmed) {
          resolve({ name: result.value });
        } else if (result.isDenied) {
          resolve({ name: '' })
        } else {
          resolve(null);
        }
      });
    });
  }

  input_customerTele(): Promise<any> {
    return new Promise((resolve, reject) => {
      Swal.fire({
        icon: 'info',
        title: '請輸入常用的行動電話',
        text: '方便日後通知拍照時間',
        input: 'text',
        inputPlaceholder: '09XX-XXXXXX',
        inputValue: '',
        inputAttributes: {
          maxlength: '10',
          autocapitalize: 'off',
          autocorrect: 'off',
        },
        showCancelButton: false,
        showDenyButton: false,
        confirmButtonText: '確定',
        showLoaderOnConfirm: true,
        reverseButtons: true,
        preConfirm: (tele) => {
          if (!tele || !this.verifyTele(tele)) {
            Swal.showValidationMessage('行動電話格式錯誤，格式：09XXXXXXXX'); 
          } else {
            return tele;
          }
        },
        allowOutsideClick: false,
      }).then((result) => {
        // console.log(result);
        if (result.isConfirmed) {
          resolve({ tele: result.value });
        } else if (result.isDenied) {
          resolve({ tele: '' })
        } else {
          resolve(null);
        }
      });
    });
  }
  input_customerSex(defaultValue: string): Promise<any> {
    return new Promise((resolve, reject) => {
      Swal.fire({
        icon: 'info',
        title: '請選擇小朋友性別',
        text: '',
        input: 'radio',
        inputValue: defaultValue,
        inputOptions: {
          '男': '男',
          '女': '女',
        },
        showCancelButton: false,
        showDenyButton: false,
        confirmButtonText: '確定',
        showLoaderOnConfirm: true,
        reverseButtons: true,
        preConfirm: (sex) => {
          if (!sex) {
            Swal.showValidationMessage('請選擇小朋友性別'); 
          } else {
            return sex;
          }
        },
        allowOutsideClick: false,
      }).then((result) => {
        // console.log(result);
        if (result.isConfirmed) {
          resolve({ sex: result.value });
        } else if (result.isDenied) {
          resolve({ sex: '' })
        } else {
          resolve(null);
        }
      });
    });
  }


  private verifyTele(input_value: string): boolean {
    let isValid: boolean = false;
    if (!input_value) isValid;

    /***** 轉半形 *****/
    let output_value = this.transformService.toCDB(input_value);
    output_value = output_value.slice(0, 10);

    const first_code = output_value[0] ? output_value[0] : '';
    const second_code = output_value[1] ? output_value[1] : '';
    const last_eight_code = output_value.slice(2);
    
    /***** 規則 09XX-XXXXXX *****/
    /***** 第1碼 0 *****/
    const pattern1 = /^[0]$/;
    /***** 第2碼 9 *****/
    const pattern2 = /^[9]$/;
    /***** 第3-10碼 數字 *****/
    const pattern3 = /^\d*$/;
    
    if (first_code && !pattern1.test(first_code)) {
      output_value = first_code.replace(/[^0]$/g, '');
    } else if (second_code && !pattern2.test(second_code)) {
      output_value = first_code + second_code.replace(/[^9]$/g, '');
    } else if (last_eight_code && !pattern3.test(last_eight_code)) {
      output_value = first_code + second_code + last_eight_code.replace(/[^\d]$/g, '');
    } else if (output_value.length !== 10) {
    } else {
      isValid = true;
    }

    return isValid;
  }


}
